import { noop } from 'underscore';
import React, { useCallback, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@fluentui/react-components';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useIntersectionObserver } from '@bingads-webui-campaign-react/pmax-landing-utils';

import { CheckItems } from './config';
import { getLandingPageCostStyles } from './landing-page-cost-styles';

export function LandingPageCost({ logger }) {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getLandingPageCostStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const ref = useRef();

  const onScrollToView = useCallback(() => {
    logger.trace('LandingPageCost scrolled into view');
  }, [logger]);

  useIntersectionObserver({
    ref,
    onScrollToView,
  });

  return (
    <div ref={ref} className={classNames('landing-page-cost', classes.container)} role="region">
      <div className={classNames(classes.innerContainer, classes[`innerContainer-${displayMode}`])}>
        <div className={classNames('landing-page-cost-title', classes.title, classes[`title-${displayMode}`])}>
          {i18n.getString(_TL_('Get better returns on your time and budget with the power of AI from Microsoft Advertising'))}
        </div>
        <div className={classNames('landing-page-cost-description', classes.description)}>
          {i18n.getString(_TL_('Generate more qualified leads, calls, bookings, acquisitions, or customers with AI and automation-powered campaigns focused on your specific goals. Whether you are working with a fixed budget or are trying to hit a cost per acquisition target, Microsoft Advertising gives you the control to make that happen.'))}
        </div>
        <div className={classNames('landing-page-cost-divider', classes.divider)} />
        <div className={classNames('landing-page-cost-check-items', classes.checkItems)}>
          {CheckItems.map(item => (
            <div className={classNames('landing-page-cost-check-item', classes.checkItem)}>
              <div className={classNames('check-item-icon', classes.checkItemIcon)}>
                <Image src={item.imgSrc} height={140} alt={i18n.getString(item.text)} />
              </div>
              <div className={classNames('check-item-text', classes.checkItemText)}>
                {i18n.getString(item.text)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

LandingPageCost.propTypes = {
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

LandingPageCost.defaultProps = {
  logger: {
    trace: noop,
  },
};

